import { useState, useEffect } from "react";
import { User, Phone, Mail, Building2, ExternalLink } from "lucide-react";
import GlassCard from "@/components/GlassCard";
import { supabase } from "@/lib/supabase";
import { Button } from "@/components/ui/button";

const AgentCard = ({ agentId }) => {
    const [agent, setAgent] = useState(null);

    useEffect(() => {
        if (!agentId) return;

        const fetchAgent = async () => {
            const { data, error } = await supabase
                .from('agents')
                .select('*')
                .eq('id', agentId)
                .single();

            if (!error && data) {
                setAgent(data);
            }
        };

        fetchAgent();
    }, [agentId]);

    if (!agentId || !agent) return null;

    return (
        <GlassCard className="p-4 bg-gradient-to-br from-primary/5 to-primary/10 border-primary/20">
            <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-white/50 flex items-center justify-center shrink-0 border border-white/20 shadow-sm overflow-hidden">
                    {agent.photo_url ? (
                        <img src={agent.photo_url} alt={agent.name} className="w-full h-full object-cover" />
                    ) : (
                        <User className="w-6 h-6 text-primary" />
                    )}
                </div>
                <div className="flex-1 min-w-0">
                    <p className="text-xs font-semibold text-primary uppercase tracking-wider mb-0.5">Your Property Connect</p>
                    <h3 className="font-bold text-lg text-foreground truncate">{agent.name}</h3>
                    {agent.company && (
                        <div className="flex items-center gap-1 text-sm text-muted-foreground mb-2">
                            <Building2 className="w-3.5 h-3.5" />
                            <span className="truncate">{agent.company}</span>
                        </div>
                    )}

                    <div className="flex gap-2 mt-3">
                        {agent.phone && (
                            <Button
                                size="sm"
                                variant="outline"
                                className="h-8 rounded-lg bg-white/50 hover:bg-white text-xs gap-1.5 flex-1"
                                onClick={() => window.location.href = `tel:${agent.phone}`}
                            >
                                <Phone className="w-3.5 h-3.5" />
                                Call
                            </Button>
                        )}
                        {agent.email && (
                            <Button
                                size="sm"
                                variant="outline"
                                className="h-8 rounded-lg bg-white/50 hover:bg-white text-xs gap-1.5 flex-1"
                                onClick={() => window.location.href = `mailto:${agent.email}`}
                            >
                                <Mail className="w-3.5 h-3.5" />
                                Email
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </GlassCard>
    );
};

export default AgentCard;
